import { useEffect, useState } from "react";
import { Globe2 } from "lucide-react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import StatusBadge from "../components/StatusBadge";
import { fmtEUR, fmtDate } from "../lib/format";

export default function Projects() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/projects").then(({ data }) => setRows(data)); }, []);

  return (
    <div>
      <PageHeader title="Progetti" subtitle="Delivery e gestione progetti clienti (Business Development, Export, Lead Generation, Consulenza)" />
      {rows.length === 0 ? <div className="bg-white rounded-xl border border-slate-200 py-14 text-center text-slate-400"><Globe2 className="w-8 h-8 mx-auto mb-2 opacity-40" />Nessun progetto</div> : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden table-scroll">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-100 text-left text-xs uppercase tracking-wider text-slate-400">
              <th className="px-4 py-3 font-medium">Progetto</th><th className="px-4 py-3 font-medium">Cliente</th><th className="px-4 py-3 font-medium">Servizio</th><th className="px-4 py-3 font-medium text-right">Valore</th><th className="px-4 py-3 font-medium">Periodo</th><th className="px-4 py-3 font-medium">Stato</th>
            </tr></thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id} data-testid={`project-row-${p.id}`} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium text-slate-800">{p.name}</td>
                  <td className="px-4 py-3 text-slate-600">{p.company?.legal_name || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{p.service || "—"}</td>
                  <td className="px-4 py-3 text-right font-mono text-slate-800">{fmtEUR(p.value)}</td>
                  <td className="px-4 py-3 text-xs text-slate-500 font-mono">{fmtDate(p.start_date)} → {fmtDate(p.end_date)}</td>
                  <td className="px-4 py-3"><StatusBadge group="project_status" value={p.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
